import { useRef, useEffect } from 'react'

/**
 * Custom hook to manage focus across different input fields in the relocate flow
 * Centralizes all ref creation and focus management logic
 */
export const useFocusManagement = () => {
  const originInputRef = useRef<HTMLInputElement>(null)
  const quantityInputRef = useRef<HTMLInputElement>(null)
  const destinyInputRef = useRef<HTMLInputElement>(null)
  const documentNumberInputRef = useRef<HTMLInputElement>(null)

  /**
   * Focus on origin position input with a delay
   */
  const focusOrigin = (delay = 200) => {
    setTimeout(() => {
      if (originInputRef.current) {
        originInputRef.current.focus()
      }
    }, delay)
  }

  /**
   * Focus on quantity input with a delay
   */
  const focusQuantity = (delay = 200) => {
    setTimeout(() => {
      if (quantityInputRef.current) {
        quantityInputRef.current.focus()
      }
    }, delay)
  }

  /**
   * Focus on destiny position input with a delay
   */
  const focusDestiny = (delay = 200) => {
    setTimeout(() => {
      if (destinyInputRef.current) {
        destinyInputRef.current.focus()
      }
    }, delay)
  }

  /**
   * Focus on document number input with a delay
   */
  const focusDocumentNumber = (delay = 200) => {
    setTimeout(() => {
      if (documentNumberInputRef.current) {
        documentNumberInputRef.current.focus()
      }
    }, delay)
  }

  // Focus on origin input when the component mounts
  useEffect(() => {
    focusOrigin()
  }, [])

  return {
    refs: {
      originInputRef,
      quantityInputRef,
      destinyInputRef,
      documentNumberInputRef
    },
    focusOrigin,
    focusQuantity,
    focusDestiny,
    focusDocumentNumber
  }
}